exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  display: block;\n  padding: 0 16px;\n}\n\nh2 {\n  font-size: 20px;\n  font-weight: 500;\n  letter-spacing: 0.005em;\n  margin-bottom: 0;\n  margin-top: 0.83em;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/rubylover/Work/new_vin_photo/site/web/src/app/help/help.component.css
// module id = ../../../../../src/app/help/help.component.css
// module chunks = main